import React from 'react'

import Skeleton from '@material-ui/lab/Skeleton'

const HeadtMapLoadre = ({ width }) => {
  return (
    <div className="heatmap_loader">
      <Skeleton
        className="heatmap_loader_container"
        variant="rect"
        height={357}
        width={width}
      />
    </div>
  )
}

export default HeadtMapLoadre
